import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InitializerService } from '../../../initializer.service';
import { urlApi } from '../../../utils/apiConfig';

interface MessageAttributes {
  idmessage: number;
  title: string;
  message: string;
}


@Injectable()
export class MessagesService {
 

  constructor(private http: HttpClient, ) {
   }

  public getMessages(): Observable<any> {
    return this.http.get(urlApi+'/app/messages');
  }

  // Adicionar mensagem
  public addMessage(newMessage: any): Observable<any> {
    return this.http.post(urlApi+'/app/messages', newMessage );
  }

  // Atualizar mensagem
  public updateMessage(objectData: MessageAttributes): Observable<any> {
    return this.http.patch(urlApi+'/app/messages', objectData);
  }

  // Excluir mensagem
  public deleteMessage(messageId: number): Observable<any> {
   
    return this.http.delete(urlApi+`/app/messages/${messageId}`);
  }

}
